/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import ds from 'designsystem';
import Fade from 'react-reveal/Fade';
import { inject, observer } from 'mobx-react';
import { CardSlide } from 'models';
import { media } from 'designsystem/index';
import { FADE_VALUES } from 'animations/Animations';
import Header4 from 'elements/Header4';
import Paragraph from 'elements/Paragraph';

import { safeHtmlWithBr } from 'common/methods/string';
import Icon from './Icon';

const FeatureCardBox = styled.div`
    display: flex;
    width: 100%;
    min-height: 490px;
    justify-content: flex-start;
    flex-flow: column nowrap;
    padding: ${ds.get('metrics.base')} ${ds.get('metrics.m')};
    background: ${ds.brand('white')};
    margin-right: ${ds.get('metrics.s')};

    ${media.tablet`
      min-width: 320px;
      width: 95%;
      min-height:500px;
    `}

    ${media.desktop`
      min-height:510px;
      padding: ${ds.get('metrics.base')} ${ds.get('metrics.l')};
      padding-top: ${ds.get('metrics.m')};
    `};
`;

FeatureCardBox.Icon = Icon;

const StyledHeader = Header4.extend`
  margin-bottom: 0;
  ${media.desktop`
    margin-bottom: ${ds.get('metrics.xs')};
  `}
`;

@inject('windowStore')
@observer
export default class FeatureCard extends Component {
  render() {
    const {
      featureCard: {
        logo,
        title,
        description,
      },
      index,
      windowStore,
    } = this.props;
    return (
      <Fade
        bottom
        distance={`${FADE_VALUES.BOX.LARGE}`}
        delay={windowStore.isOnMobile ? FADE_VALUES.DELAY.SMALL : FADE_VALUES.DELAY.SMALL * index}
      >
        <FeatureCardBox>
          <FeatureCardBox.Icon
            src={windowStore.adjustImageSize(logo)}
          />
          <StyledHeader
            dangerouslySetInnerHTML={{
              __html: safeHtmlWithBr(title),
            }}
          />
          <Paragraph
            dangerouslySetInnerHTML={{
              __html: safeHtmlWithBr(description),
            }}
          />
        </FeatureCardBox>
      </Fade>
    );
  }
}

FeatureCard.propTypes = {
  featureCard: PropTypes.instanceOf(CardSlide).isRequired,
  index: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/kentico-blocks/CardSlider/FeatureCard/index.jsx